import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  Event,
  NavigationCancel,
  NavigationCancellationCode,
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map } from 'rxjs';

function isTerminalNavigationEvent(
  event: Event,
): event is NavigationEnd | NavigationCancel | NavigationError {
  if (event instanceof NavigationCancel) {
    return (
      event.code !== NavigationCancellationCode.Redirect &&
      event.code !== NavigationCancellationCode.SupersededByNewNavigation
    );
  }
  return event instanceof NavigationEnd || event instanceof NavigationError;
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly router = inject(Router);

  readonly title = signal('imageReviewTool');

  readonly initialNavigationSettled = toSignal(
    this.router.events.pipe(
      filter(isTerminalNavigationEvent),
      map(() => true),
    ),
  );
}
